module.exports = __webpack_public_path__ + "static/img/logo.web.e893a68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/logo.web.png
// module id = 1419
// module chunks = 382